
import React from 'react';
import { Activity } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-20 border-t border-[#474d57]/30 text-center bg-transparent mt-12">
      <div className="flex flex-col items-center">
        <div className="flex items-center gap-3 mb-8">
          <div className="bg-[#00ff66] p-1.5 rounded-lg shadow-[0_0_20px_rgba(0,255,102,0.5)]">
            <Activity className="text-black" size={22} strokeWidth={3} />
          </div>
          <span className="text-xl font-black tracking-tighter uppercase text-white">FIFA<span className="text-[#00ff66]">LYTICS</span></span>
        </div>

        <p className="text-[#00ff66] text-[10px] font-black uppercase tracking-[0.4em] mb-4 px-4">
          © {currentYear} FIFALYTICS PRO • IDEALIZADO PELO DUPLA FIFA SOLUTIONS
        </p>

        <p className="text-[#848e9c] text-[8px] font-bold uppercase tracking-[0.15em] max-w-2xl mx-auto opacity-70 leading-relaxed px-6">
          APOSTAS ESPORTIVAS ENVOLVEM RISCO NO FIFA ONLINE. OPERE COM RESPONSABILIDADE. ESTA FERRAMENTA<br className="hidden md:block" />
          É PARA FINS ANALÍTICOS E NÃO GARANTE LUCROS FINANCEIROS.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
